import React, { useEffect, useState, useRef } from 'react';
import { collection, onSnapshot, doc, setDoc, addDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { firestore } from './../../FirebaseUtils';
import AdminNewsCard from './AdminNewsCard';
import { Alert, Button } from 'react-bootstrap';

function AdminNews() {
    const [ loading, setLoading ] = useState(true);
    const [ errorMessage, setErrorMessage ] = useState();

    const [ news, setNews ] = useState([]);

    useEffect(() => {
        // Get a reference to the "questions" collection
        const newsRef = collection(firestore, 'news');

        // Listen for changes in the collection
        const unsubscribe = onSnapshot(newsRef, (snapshot) => {
            setErrorMessage("");
            setLoading(true);
    
            const newsData = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));
            setNews(newsData);

            console.log(newsData);

            setLoading(false);
        });

        // Clean up the listener on unmount
        return () => unsubscribe();

    }, []);

    async function onClickAddNews(e) {
        const now = new Date();
        const timestamp = now.getFullYear() + ('0' + (now.getMonth() + 1).toString()).slice(-2) + ('0' + now.getDate()).slice(-2) + ('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2) + ('0' + now.getSeconds()).slice(-2);

        const startDate = formatDate(now);
        const endDate = formatDate(now);

        try {
            await addDoc(collection(firestore, 'news'), {
                active: false,
                timestamp: timestamp,
                startDate: startDate, // To avoid empty startDate, I will initialize it
                endDate: endDate, // To avoid empty endDate, I will initialize it
                header: 'กรุณากดปุ่ม Edit เพื่อระบุหัวข้อ',
                description: 'กรุณากดปุ่ม Edit เพื่อระบุข้อความ',
                sent: false,
            });
        } 
        catch (error) {
            console.error('Error adding news: ', error);
        }
    }

    async function deleteNews(docId) {
        try {
            await deleteDoc(doc(firestore, 'news', docId));
        }
        catch (error) {
            console.error('Error deleting document: ', error);
        }
    }

    function formatDate(d) {
        return `${d.getFullYear()}-${('0'+(d.getMonth()+1).toString()).slice(-2)}-${('0'+d.getDate()).slice(-2)} ${('0'+d.getHours()).slice(-2)}:${('0'+d.getMinutes()).slice(-2)}:${('0'+d.getSeconds()).slice(-2)}`;
    }

    async function saveNews(docId, active, header, description, startDate, endDate) {

        const docRef = doc(firestore, 'news', docId);
        try {
            await updateDoc(docRef, {
                active: active,
                header: header,
                description: description,
                startDate: startDate,
                endDate: endDate,
                sent: false,
            });
        }
        catch (error) {
            console.error('Error updating news: ', error);
        }
    }

    return (
        <div className='top-center-container'>
            <div className='mb-3'><Button onClick={onClickAddNews} disabled={loading}>Add News</Button></div>

            { loading ? <div className='mt-5'><Alert variant='info'>Loading ...<br />Please wait</Alert></div> : null }

            {
                news && news.length > 0?
                    news.map((eachNews, i) => {
                        return (
                            <div className='mt-3' key={`news_${i}`}>
                                <AdminNewsCard 
                                    id={eachNews.id}
                                    active={eachNews.active}
                                    header={eachNews.header}
                                    description={eachNews.description}
                                    startDate={eachNews.startDate}
                                    endDate={eachNews.endDate}
                                    sent={eachNews.sent}

                                    deleteNews={deleteNews}
                                    saveNews={saveNews}
                                />
                            </div>
                        );
                    })
                :
                    null
            }
        </div>
    );
}

export default AdminNews;
